/**
 *
 * FormSubscriptionTypeSelect
 *
 */
import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { FieldInputProps, FormikProps } from 'formik';
import { SubscriptionType } from 'types/models';
import { IconText } from '../IconText';
import {
  InternalSubTypeIcon,
  CustomerSubTypeIcon,
} from '../Icons/Subscriptionicons';
import { FormHelperText, styled } from '@mui/material';
import clsx from 'clsx';
import { makeThemeStyle } from 'styles/makeThemeStyle';

interface Props {
  form: FormikProps<any>;
  field: FieldInputProps<any>;
}

const useStyles = makeThemeStyle(theme => ({
  errButton: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  toggleBtnGroup: {
    height: '56px', //Tries to match the height of textField
  },
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&.Mui-selected': {
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.primary.light,
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.light,
  },
  selected: {},
}));

export function FormSubscriptionTypeSelect(props: Props) {
  const {
    field,
    form: { setFieldValue, errors, validateField },
  } = props;
  const classes = useStyles();
  const [type, setType] = React.useState<SubscriptionType>(field.value);

  React.useEffect(() => {
    validateField(field.name);
  }, [field.name, validateField]);

  const handleTypeChange = (
    e: React.MouseEvent<HTMLElement>,
    newType: SubscriptionType,
  ) => {
    if (newType) {
      setType(newType);
      setFieldValue(field.name, newType, true);
    }
  };

  const error = errors[field.name];

  return (
    <>
      <ToggleButtonGroup
        value={type}
        exclusive
        onChange={handleTypeChange}
        aria-label="text alignment"
        className={clsx(classes.toggleBtnGroup, {
          [classes.errButton]: !!error,
        })}
      >
        <StyledToggleButton value="internal" aria-label="internal aligned">
          <IconText icon={<InternalSubTypeIcon />} text="internal" />
        </StyledToggleButton>
        <StyledToggleButton value="customer" aria-label="customer aligned">
          <IconText icon={<CustomerSubTypeIcon />} text="customer" />
        </StyledToggleButton>
      </ToggleButtonGroup>
      <FormHelperText error={!!error}>{error as string}</FormHelperText>
    </>
  );
}
